<p-tabView (onChange)="tabChanged(tabIndex, $event)" *ngIf="vendorInfo" [(activeIndex)]="tabIndex" class="p-0"
           styleClass="tabview-custom custom-color-tabs p-0-tabview ml-4">

  <!--Create Vendor-->
  <p-tabPanel>
    <ng-template pTemplate="header">
      <span class="custom-span">Vendors</span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-vendor-list [isVendorCreateTab]="isVendorCreateTab"></app-vendor-list>
    </ng-template>
  </p-tabPanel>

  <!--Vendor Invitations-->
  <p-tabPanel *ngIf="isSendInvitationEnabled()">
    <ng-template pTemplate="header">
      <span class="custom-span">Vendor Invitations</span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-vendor-invitation [isInvitationTab]="isVendorInvitationTab"></app-vendor-invitation>
    </ng-template>
  </p-tabPanel>

  <!--Vendor Requests-->
  <p-tabPanel *ngIf="isVendorRequestEnabled()">
    <ng-template pTemplate="header">
      <span class="custom-span">Vendor Requests</span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-vendor-request></app-vendor-request>
    </ng-template>
  </p-tabPanel>

  <!--Vendor Groups-->
  <p-tabPanel *ngIf="isVendorGroupEnabled()">
    <ng-template pTemplate="header">
      <span class="custom-span">Vendor Groups</span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-vendor-group [isVendorGroupTab]="isVendorGroupTab"></app-vendor-group>
    </ng-template>
  </p-tabPanel>

  <!--Community Vendors-->
  <p-tabPanel *ngIf="isCommunityVendorsEnabled()">
    <ng-template pTemplate="header">
      <span class="custom-span">Community Vendors</span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-vendor-table></app-vendor-table>
    </ng-template>
  </p-tabPanel>
</p-tabView>
